import { ISelectOptions } from "../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { Host } from "../../yoello-lib/modules/host/Hosts";

/**self sign up reducer state */
export interface ISelfsignupState {
    stage: ESignupStages;
    title: string;
    userData?: IUserData;
    venueData?: IVenueData;
    selectedSubscription: string | null;
    host: Host;
    leadData?: Partial<ILead>
    reseller?: string;
    leadId?: string;
    salesRef?: string;
    acquirerData?: IAcquirer;
    hubspotId?: string;
}

/**self sign up context return state  */
export interface ISelfsignupContext extends ISelfsignupState {
    dispatch: any;
    goBack: () => void;
    selectSubscription: (id: string | null) => void;
    removeSnapshot: () => void;
    callLeadsAPI: <T>(body: T) => Promise<void>;
    completeSignup: () => Promise<boolean>;
    emailLookup: (email: string) => Promise<boolean>;
    getTransactionFeePlans:(resellerName: string)=> Promise<FeePlans[]|[]>;
}

export interface ISelfsignupProviderProps {
    children: JSX.Element;
}

export interface IUserData {
    first_name: string;
    last_name: string;
    contact_phone: string;
    contact_email: string;
}

export interface IVenueData {
    venue_name: string;
    venue_location: ISelectOptions;
    total_venues: string;
}

export interface ISelfsignupAction {
    type: string;
    payload?: ActionPayload;
}

export type ActionPayload = {} | null;


export enum ESignupStages {
    DETAILS = "DETAILS",
    VENUE = "VENUE",
    SUBSCRIPTION = "SUBSCRIPTION",
    COMPLETED = "COMPLETED",
    INVALIDLOCATION = "INVALIDLOCATION",
    ACQUIRER = "ACQUIRER"
}

export interface ILead extends IUserData, IVenueData {
    specialist_name: string;
    specialist_email: string;
    reseller?: string;
    processing_fee_plan_id?: string;
}

export interface ISubscriptions {
    id: string;
    name: string;
    priceOptions: {
        price: number,
        percent: number,
        tier: string;
    },
    currency: string;
}

export enum OnboardingSources {
    partners = "YOELLO",
    barclaycard = "BARCLAYCARD",
    square = "SQUARE",
    rms = "RMS",
    eposnow = "EPOSNOW",
    cardsaver = "CARD_SAVER",
    worldpay = "WORLDPAY",
    zerobubble = "ZEROBUBBLE",
    deliverect= "DELIVERECT",
    ncr = "NCR",
    bna = "BNA",
    oracle = "ORACLE",
    zonal = "ZONAL",
    tevalis = "TEVALIS"
}


export interface IAcquirer {
    acquirer_name: string;
    mcc: string;
    mid: string;
}

export enum Acquirers {
    elavon = "elavon",
    globalPayments = "global_payments",
    FiServ = "FiServ",
    AIBMerchantServices = "AIB Merchant Services",
    Worldpay = 'Worldpay',
    barclaycard = 'barclaycard'
}

export interface FeePlans {
    created_on: string,
    deleted: boolean,
    id: string,
    metadata_: any,
    name_public: string,
    order_processing_charge: number,
    order_processing_charge_percentage: number,
    serial_id: number,
    updated_on: string,
}